import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { saveMarketingLanguage } from '@/i18n/marketing'
import './home/marketing-language.css'
import { Outlet, useLocation } from 'react-router-dom'
import BrandHeader from './home/BrandHeader'
import BrandFooter from './home/BrandFooter'
import { loadGtm } from '@/lib/gtm'
import { loadNaverWcs } from '@/lib/naver'

export default function HomeLayout() {
  const { t, i18n } = useTranslation('marketing')
  const location = useLocation()
  const language = i18n.resolvedLanguage === 'en' ? 'en' : 'ko'
  const koreanOnly = /^\/(reviews|announcements|brochure)(\/|$)/.test(location.pathname)

  useEffect(() => {
    const requested = new URLSearchParams(location.search).get('lang')
    if (requested === 'en' || requested === 'ko') {
      saveMarketingLanguage(requested)
      void i18n.changeLanguage(requested)
    }
  }, [location.search, i18n])

  useEffect(() => {
    const previous = document.documentElement.lang
    const previousTitle = document.title
    document.title = t('pageTitle')
    document.documentElement.lang = language
    document.documentElement.dataset.marketingLanguage = language
    return () => {
      document.title = previousTitle
      document.documentElement.lang = previous
      delete document.documentElement.dataset.marketingLanguage
    }
  }, [language, t])

  useEffect(() => {
    loadGtm()
    loadNaverWcs()
  }, [])

  return (
    <div lang={language} className="marketing-home min-h-screen flex flex-col bg-white text-gray-900">
      <BrandHeader />
      <main className="flex-1">
        {language === 'en' && koreanOnly && (
          <p className="mx-auto max-w-7xl px-6 py-4 text-sm text-qb-text-mid bg-qb-bg-secondary">
            {t('koreanOnly')}
          </p>
        )}
        <Outlet />
      </main>
      <BrandFooter />
    </div>
  )
}
